
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import { useRoute } from "vue-router";
import { ScrollComponent } from "@/assets/ts/components/_ScrollComponent";
import { MenuComponent } from "@/assets/ts/components/MenuComponent";
import routeItems from "@/router/routeItems";
import SubMenu from "@/layout/aside/SubMenu.vue";
import { useStore } from "vuex";

export default defineComponent({
  name: "kt-menu",
  components: {
    SubMenu,
  },
  setup() {
    const { t, te } = useI18n();
    const route = useRoute();
    const store = useStore();
    const scrollElRef = ref<null | HTMLElement>(null);

    onMounted(() => {
      ScrollComponent.reinitialization();
      MenuComponent.reinitialization();
      if (scrollElRef.value) {
        scrollElRef.value.scrollTop = 0;
      }
    });

    const translate = (text) => {
      if (te(text)) {
        return t(text);
      } else {
        return text;
      }
    };

    return {
      translate,
      routeItems,
      hasPermission (item) {
        let user = store.getters.currentUser
        if(!item.meta || user.is_superuser === true) return true
        if(!user.permissions) return false
        if (item.meta.is_superuser)
          return user.is_superuser === true
        else if (item.meta.is_staff)
          return user.is_staff === true
        else if (item.meta.permission)
          return user.permissions.indexOf(user.site_id + ':' + item.meta.permission) > -1
        else
          return false
      }
    };
  },
});
